import {
  useSearchModeFromRoute,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { useModalityChangeCounterStore } from '@aibees/elephant/store/modality-change-counter';
import { useWorkspace } from '@aibees/shared/workspace';
import {
  useBrowseCompanySearchCore,
  type BrowseCompanySearchDeps,
} from './use-browse-company-search';

/**
 * Table-specific wrapper for the advance-table `browseApi` config.
 *
 * Reads only lightweight deps (workspace, type, mode, modalityVersion)
 * from hooks/context. Does NOT subscribe to `useSearchQueryFilter` —
 * the search params arrive through the `params` argument provided by
 * `useBrowseApiDataCore`, which already debounces them.
 *
 * This eliminates the redundant `useSearchQueryFilter` + `useDeferredValue`
 * subscriptions that caused excessive re-renders (~500 per filter change).
 */
export function useBrowseCompanySearchForTable(params: Record<string, any>) {
  const workspace = useWorkspace()?.id;
  const type = useSearchTypeFromRoute();
  const mode = useSearchModeFromRoute();
  const { counter: modalityVersion } = useModalityChangeCounterStore();

  const { page, size, sort, ...searchParams } = params;

  const deps: BrowseCompanySearchDeps = {
    workspace,
    type,
    mode,
    searchParams,
    modalityVersion,
  };

  return useBrowseCompanySearchCore(
    { page: page || 0, size: size || 25, sort },
    deps
  );
}
